var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgListCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 2.66671H14V4.00004H5.33333V2.66671ZM2 2.33337H4V4.33337H2V2.33337ZM2 7.00004H4V9.00004H2V7.00004ZM2 11.6667H4V13.6667H2V11.6667ZM5.33333 7.33337H14V8.66671H5.33333V7.33337ZM5.33333 12H14V13.3334H5.33333V12Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list-check.2b0212cd.svg";
export { ForwardRef as ReactComponent };